module.exports = __webpack_public_path__ + "img/main_btn01.cd759036.jpg";